// Bright amber → lime → emerald → cyan → blue spectrum. The bar fill is a
// solid color sampled from this spectrum at the current %, so the whole bar
// is uniform but its color shifts as the campaign fills up. When `animated`
// is true the .progress-stripes class (see tailwind.css) overlays scrolling
// diagonal stripes so the bar still reads as "live" without a value change.
const PROGRESS_STOPS = [
  { p: 0, r: 0xfb, g: 0xbf, b: 0x24 },
  { p: 25, r: 0x84, g: 0xcc, b: 0x16 },
  { p: 50, r: 0x22, g: 0xc5, b: 0x5e },
  { p: 75, r: 0x06, g: 0xb6, b: 0xd4 },
  { p: 100, r: 0x3b, g: 0x82, b: 0xf6 },
];

const colorAtPct = (pct) => {
  const p = Math.max(0, Math.min(100, pct));
  for (let i = 0; i < PROGRESS_STOPS.length - 1; i++) {
    const a = PROGRESS_STOPS[i];
    const b = PROGRESS_STOPS[i + 1];
    if (p >= a.p && p <= b.p) {
      const t = (p - a.p) / (b.p - a.p);
      const r = Math.round(a.r + (b.r - a.r) * t);
      const g = Math.round(a.g + (b.g - a.g) * t);
      const bb = Math.round(a.b + (b.b - a.b) * t);
      return `rgb(${r}, ${g}, ${bb})`;
    }
  }
  const last = PROGRESS_STOPS[PROGRESS_STOPS.length - 1];
  return `rgb(${last.r}, ${last.g}, ${last.b})`;
};

export default function FillBar({ used, cap, animated = true }) {
  const total = Number(cap) || 0;
  const value = Number(used) || 0;
  if (total <= 0) return null;
  const pct = Math.min(100, Math.max(0, (value / total) * 100));
  return (
    <div
      className="mt-2 h-2.5 w-full overflow-hidden rounded-full border-2 border-(--text-faint) bg-(--surface-2)"
      title={`${pct.toFixed(1)}%`}
    >
      <div
        className={`h-full rounded-full transition-[width] duration-700 ease-out ${animated ? "progress-stripes" : ""}`}
        style={{
          width: `${pct}%`,
          backgroundColor: colorAtPct(pct),
        }}
      />
    </div>
  );
}
